<template>
  <div id="pci" class="d-flex">
    <transition name="fade">
      <div v-if="alerts.length && showAlerts" id="alerts-container">
        <div class="d-flex flex-wrap justify-content-center w-100 pb-1">
          <div v-for="(alert, index) in alertGroups" :key="index" @click="onFilterAlertRows(alert)" class="alert-group border rounded d-flex align-items-center justify-content-center pointer mx-1" :class="{'selected' : alertFilter === alert}">
            <i
              :class="alert.class"
              class="text-danger"
              style="font-size: 1rem;"
              v-b-tooltip.hover :title="alert.name"
            />
          </div>
        </div>
        <div id="alert-cards">
          <b-card class="mb-1 pointer alert-custom" no-body v-for="(alert, index) in alertsFiltered" :key="index" style="z-index: 9999;">
            <template #header>
              <div
                class="d-flex"
              >
                <span
                  class="mr-2"
                  v-if="alert.pciModeloItemValid && alert.pciModeloItemValid.alertaGrupoID"
                  :class="alert.pciModeloItemValid.alertaGrupo.icone"
                >
                </span>
                <span v-html="alert.mensagem" @click="onAlertClicked(alert)">
                </span>
              </div>
              <div class="d-flex justify-content-end">
                <div style="font-size: 0.75em;">
                  {{ alert.dataAcaoFormatada }}
                </div>
              </div>
            </template>
          </b-card>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div v-if="showQuotes" id="quotes-container">
        <b-card class="mb-1">
          <template #header>
            <strong>Status {{ $lang.PCI.AT.TitleQuote }}</strong>
          </template>
          <div id="quotes-cards">
            <b-card class="mb-0 mt-1 pointer quotes-custom" no-body v-for="ctr in Object.keys(quotes).filter(k => k !== 'Total').sort((a,b) => a.localeCompare(b))" :key="ctr">
              <template #header>
                <div style="z-index: 9999;">
                  <div class="my-2" @click="onOpenQuotes(ctr)">
                    <div class="d-flex flex-wrap">
                      <strong>{{ ctr }}</strong>
                    </div>
                    <div v-for="key in Object.keys(quotes[ctr])" :key="key" style="z-index: 9999;">
                      {{ quotes[ctr][key] }} - <i class="fas fa-circle" :class="{'rejected' : key > 0 && key < 5,
                                                                                 'revision': key == 10 || key == 12,
                                                                                 'reg-approve': key == 16 || key == 18,
                                                                                 'filled': key == 20,
                                                                                 'plan-approve': key == 22,
                                                                                 'finished': key == 50 }">
                      </i> {{ $lang.PCI.AT['Status' + key] }}
                    </div>
                  </div>
                </div>
              </template>
            </b-card>
          </div>
        </b-card>
      </div>
    </transition>
    <div id="pci-grid" class="order-2 flex-grow-1">
      <div class="pci-header d-flex align-items-center p-1">
        <div class="d-flex align-items-center col-md-4 pr-0 h-80">
          <img src="https://static.zopone.com.br/img/logotipo/zopone.png" style="width:180px;opacity:50%;" alt="">
          <b-button @click="onLoadGridValues(false)" variant="light" class="mx-2 z-tooltip">
            <span class="z-tooltiptext z-position-bottomright">{{ $lang.Common.Tooltip.ButtonReload }}</span>
            <i class="fas fa-sync-alt pci-header-button"></i>
          </b-button>
          <b-form-input type="search"
                  :placeholder="$lang.Common.Buttons.Search + '...'"
                  v-model="searchField"
                  class="py-1 h-100"
                  @input="onSearchFieldChanged"/>
        </div>
        <!-- <div class="col-md-7"> -->
        <div class="d-flex col">
          <b-button @click="onRestorePinned" variant="light" class="z-tooltip">
            <span class="z-tooltiptext z-position-bottomright">{{ $lang.PCI.Spreadsheet.RestorePinned }}</span>
            <i class="fas fa-thumbtack pci-header-button"></i>
          </b-button>
          <b-button @click="onFilterRow" v-if="!rowFiltered" variant="light" class="z-tooltip">
            <span class="z-tooltiptext z-position-bottomright">{{ $lang.PCI.Spreadsheet.FilterCurrentRow }}</span>
            <i class="fas fa-filter pci-header-button"></i>
          </b-button>
          <b-button @click="onFilterRow" v-else variant="warning" class="z-tooltip">
            <span class="z-tooltiptext z-position-bottomright">{{ $lang.PCI.Spreadsheet.ResetFilter }}</span>
            <i class="fas fa-filter" style="font-size: 13px;"></i>
          </b-button>
          <b-button @click="onShowAllColumns" variant="light" class="z-tooltip">
            <span class="z-tooltiptext z-position-bottomright">{{ $lang.PCI.Spreadsheet.ShowAllColumns }}</span>
            <i class="fas fa-th pci-header-button"></i>
          </b-button>
          <b-button @click="onSaveLayout" variant="light" class="z-tooltip">
            <span class="z-tooltiptext z-position-bottomright">{{ $lang.PCI.Spreadsheet.SaveCurrentLayout }}</span>
            <i class="fas fa-save pci-header-button"></i>
          </b-button>
          <b-button @click="onLoadLayout" variant="light" class="z-tooltip">
            <span class="z-tooltiptext z-position-bottomright">{{ $lang.PCI.Spreadsheet.LoadSavedLayout }}</span>
            <i class="fas fa-folder-open pci-header-button"></i>
          </b-button>
          <b-button @click="onShowConsiderations" variant="light" v-if="hasRole(roles.RW_OPER_PCI_DOCUMENTATION) || hasRole(roles.R_OPER_PCI_DOCUMENTATION)" class="z-tooltip">
            <span class="z-tooltiptext z-position-bottomright">{{ $lang.PCI.Spreadsheet.ContractConsiderations }}</span>
            <i class="fas fa-book"></i>
          </b-button>
          <b-button @click="onShowAnnex" variant="light" v-if="hasRole(roles.RW_OPER_PCI_DOCUMENTATION) || hasRole(roles.R_OPER_PCI_DOCUMENTATION)" class="z-tooltip">
            <span class="z-tooltiptext z-position-bottomright">{{ $lang.PCI.Spreadsheet.ContractAnnex }}</span>
            <i class="fas fa-paperclip"></i>
          </b-button>
          <b-button @click="onAutosizeAllColumns" variant="light" class="z-tooltip">
            <span class="z-tooltiptext z-position-bottomright">{{ $lang.AGGrid.autosizeAllColumns }}</span>
            <i class="fas fa-text-width"></i>
          </b-button>
          <b-button variant="light" href="https://app.powerbi.com/reportEmbed?reportId=479dbdd3-39b1-4091-ab2a-fe8e0bfc8dda&autoAuth=true&filterPaneEnabled=false&navContentPaneEnabled=false" target="_blank" class="z-tooltip">
            <span class="z-tooltiptext z-position-bottomright">{{ $lang.Common.Buttons.PciSummary }}</span>
            <i class="fas fa-chart-pie"></i>
          </b-button>
        </div>
        <!-- <div class="d-flex col-md-1 mr-0 justify-content-end align-items-center"> -->
        <div class="d-flex col-auto justify-content-end align-items-center">
          <span v-if="obraIdFiltro" class="badge badge-warning mr-2 py-2 px-2" style="font-size: 13px;">
            <i class="fas fa-filter mr-1"></i>{{ $lang.PCI.Spreadsheet.FilteredByWork }} {{ obraRefFiltro }}
          </span>
          <div class="z-tooltip mr-1" @click.prevent.stop="onShowQuotes">
            <span class="z-tooltiptext z-position-bottomleft">{{ $lang.PCI.Spreadsheet.Quotes }}</span>
            <i class="fas fa-pencil-ruler py-1 px-2 border rounded text-third" style="font-size: 20px;">
              <span class="badge badge-primary mr-1" style="font-size: 12px;">{{ quotes.Total }}</span>
            </i>
          </div>
          <div v-if="!loadingAlerts"
               @click.prevent.stop="onShowAlerts"
               :style="{ 'cursor': alerts.length ? 'pointer' : 'default' }"
               class="z-tooltip">
            <span class="z-tooltiptext z-position-bottomleft">{{ $lang.PCI.Spreadsheet.Alerts }}</span>
            <i :class="alertsStyle" class="py-1 px-2 border rounded" style="font-size: 20px; color: red;">
              <span v-if="alerts.length" class="badge badge-primary" style="font-size: 12px;">{{ alertsFiltered.length }}</span>
            </i>
          </div>
          <div v-else>
            <img src="/static/img/loader.gif" alt="">
          </div>
        </div>
      </div>
      <div id="gridPci">
        <ag-grid-vue style="width: 100vw; height: calc(100vh - 60px - 35px - 26px)"
                     class="ag-theme-alpine"
                     :rowMultiSelectWithClick="false"
                     :enableRangeSelection="true"
                     :getLocaleText="localeTextFunc"
                     :gridOptions="pciDataGridOptions"
                     :undoRedoCellEditing="true"
                     :undoRedoCellEditingLimit="20"
                     :columnTypes="columnTypes"
                     :defaultColDef="defaultColumnDef"
                     :sideBar="sideBar"
                     rowGroupPanelShow="never"
                     groupDisplayType="groupRows"
                     :groupDefaultExpanded="-1"
                     :tooltipShowDelay="200"
                     :columnDefs="columnDefs"
                     :getRowId="params => params.data.obraId + params.data.obraCandidatoId"
                     :getContextMenuItems="getContextMenuItems"
                     :cacheQuickFilter="true"
                     :suppressLastEmptyLineOnPaste="true"
                     :processDataFromClipboard="processDataFromClipboard"
                     :processCellForClipboard="processCellForClipboard"
                     :excelStyles="excelStyles"
                     :allowDragFromColumnsToolPanel=true
                     @firstDataRendered="onFirstDataRendered"
                     @cellDoubleClicked="beforeEdit"
                     @cellEditingStarted="beforeEdit"
                     @cellValueChanged="onEdit"
                     @filterChanged="onFilterChanged"
                     @gridReady="onGridPCIReady"
                     @toolPanelVisibleChanged="onToolPanelVisibleChanged"
                     @asyncTransactionsFlushed="onFilterChanged"
                     >
                     <!--
                     :rowData="rowData"
                     clipboardDelimiter="=|="
                     @columnResized="onColumnResized"
                     @columnVisible="onLayoutChanged"
                     @columnMoved="onLayoutChanged"
                     @columnPinned="onLayoutChanged"
                     @columnRowGroupChanged="onLayoutChanged"
                     -->
        </ag-grid-vue>
        <ag-grid-vue style="height: 60px; margin-left: auto; margin-right: 20px; overflow-y: scroll; border-top: 1px solid gray;" id="pci-count"
                     class="ag-theme-material"
                     :getLocaleText="localeTextFunc"
                     :columnTypes="countColumnTypes"
                     :gridOptions="pciCountGridOptions"
                     :columnDefs="countColumnDefs"
                     :rowData="pciCountRowData"
                     :headerHeight="0">
        </ag-grid-vue>
        <div class="pci-header d-flex align-items-center p-1" style="height:25px;">
          <i class="fas fa-filter px-2"></i>
          <v-select ref="filterHistory"
                    id="filter-history"
                    appendToBody
                    :calculatePosition="withPopper"
                    :options="filterList"
                    v-model="filterSelected"
                    class="w-100"
                    :searchable="false"
                    @input="onChangeFilter"
                    :placeholder="$lang.Common.Buttons.History + '...'">
            <template #no-options>
              <span>...</span>
            </template>
          </v-select>
        </div>
      </div>
    </div>

    <!-- Seleção de arquivos ZDocs-->
    <FileSelection
      ref="zDocs"
      v-if="showZdocs"
      @hide="showZdocs = false"
      :startupFolderId="selectedFolderId">
    </FileSelection>

    <!-- Seleção de arquivos ZDocs-->
    <FileSelection
      ref="zDocsFolder"
      v-if="showFolderZdocs"
      @on-selected-folder="changeCurrentFolder">
      <!-- @hide="showZdocs = false" -->
    </FileSelection>

    <!-- Histórico de avaliação -->
    <b-modal
      v-model="showPdrLog"
      title="Histórico de avaliação"
      size="lg"
      :hide-footer="true"
      centered
    >
      <div style="min-height: 500px;">
        <b-table :items="logPdr"
                 :fields="[{key: 'dataAcaoFormatada', label: this.$lang.PCI.LogPdrTable.Date},
                           {key: 'nomeContaAcao', label: this.$lang.PCI.LogPdrTable.User},
                           {key: 'descricao', label: this.$lang.PCI.LogPdrTable.Description}]"
                 :bordered="true"
                 :striped="true"
                 small>
        </b-table>
      </div>
      <!-- <SimpleTableList :objList="logPdr"></SimpleTableList> -->
    </b-modal>

    <!-- Histórico de alteração -->
    <b-modal
      v-model="showItemAlteracaoLog"
      v-if="showItemAlteracaoLog"
      title="Histórico de alteração"
      size="xl"
      :hide-footer="true"
      centered
    >
      <div style="min-height: 500px;">
        <b-table :items="logItemPci"
                 :fields="[{key: 'dataAcaoFormatada', label: $lang.PCI.LogItemTable.Date},
                           {key: 'nomeContaAcao', label: $lang.PCI.LogItemTable.User},
                           {key: 'valorAnterior', label: $lang.PCI.LogItemTable.OldValue},
                           {key: 'valorAlterado', label: $lang.PCI.LogItemTable.NewValue}]"
                 :bordered="true"
                 :striped="true"
                 small>
        </b-table>
      </div>
    </b-modal>

    <!-- modal motivo unset #NA# PDR-->
    <b-modal
      centered
      id="unsetNAReason"
      size="lg"
      v-model="showPdrSetNAReason"
      v-if="showPdrSetNAReason"
      :title="$lang.PCI.PDRSetNAReason.Title"
      :ok-title="$lang.Common.Buttons.Confirm"
      :cancel-title="$lang.Common.Buttons.Back"
      @ok="submitPDRSetNA"
      no-close-on-backdrop
    >
    <b-form-textarea
      id="PDRNaReason"
      v-model="pdrNaReason"
      placeholder=".."
      rows="3"
      max-rows="100%"
    ></b-form-textarea>
    </b-modal>

    <!-- Chamado 20121: confirmação da liberação da avaliação com pendência de aprovação no COP -->
    <b-modal
      id="confirmCopPendencias"
      size="md"
      v-model="showCopPendenciasConfirm"
      v-if="showCopPendenciasConfirm"
      :title="$lang.PCI.PDRForm.CopPendencias.Title"
      :ok-title="$lang.PCI.PDRForm.CopPendencias.Confirm"
      :cancel-title="$lang.Common.Buttons.Cancel"
      @ok="confirmCopPendencias"
      @hidden="copPendenciasRow = null"
      no-close-on-backdrop
    >
      <p>{{ $lang.PCI.PDRForm.CopPendencias.Message }}</p>
      <ul class="mb-3">
        <li v-if="copPendencias.aguardando > 0">
          {{ copPendencias.aguardando }} — {{ $lang.PCI.PDRForm.CopPendencias.WaitingSupervisor }}
        </li>
        <li v-if="copPendencias.aprovadoSupervisor > 0">
          {{ copPendencias.aprovadoSupervisor }} — {{ $lang.PCI.PDRForm.CopPendencias.WaitingCoordinator }}
        </li>
        <li v-if="copPendencias.aprovadoCoordenador > 0">
          {{ copPendencias.aprovadoCoordenador }} — {{ $lang.PCI.PDRForm.CopPendencias.WaitingPlanning }}
        </li>
      </ul>
      <p class="mb-0"><strong>{{ $lang.PCI.PDRForm.CopPendencias.Warning }}</strong></p>
    </b-modal>

    <!-- Geração de PDR -->
    <b-modal
      id="generatePdr"
      size="xl"
      v-model="showPdrTeam"
      v-if="showPdrTeam"
      :title="$lang.PCI.PDRForm.Title"
      :ok-title="$lang.Common.Buttons.Save"
      :cancel-title="$lang.Common.Buttons.Back"
      @ok="submitPDR"
      no-close-on-backdrop
    >
      <Tables ref="tableGrid" v-if="montagemPdrList != null" class="col-mdEW-12 tabela"
              :columns="[$lang.PCI.PDRForm.TableFields.Function,
                        $lang.PCI.PDRForm.TableFields.Type,
                        $lang.PCI.PDRForm.TableFields.Employee,
                        $lang.PCI.PDRForm.TableFields.PDR,
                        $lang.PCI.PDRForm.TableFields.Start,
                        $lang.PCI.PDRForm.TableFields.End,
                        $lang.PCI.PDRForm.TableFields.Form]"
              :showSearch="false"
              :showPrint="false"
              :showDownload="false"
              :showFullscreen="false"
              :showPaging="false">
        <tr v-for="obj in montagemPdrList" :key="obj.membro.id">
          <TableColumn :IsText="true" :status="obj.status" :value="obj.membro.funcaoObra.nome" />
          <TableColumn :IsText="true" :status="obj.status" :value="tipoServico(obj.membro.tipoServico)" />
          <TableColumn :IsText="true" :status="obj.status" :value="obj.membro.nome" />
          <TableColumn :IsCustom="true" class="text-center" style="font-size:15px; color:gray;">
            <span v-if="!(obj.membro.funcionario != null && obj.membro.funcionario.cargo.pdr)"><i class="far fa-square"></i></span>
            <span v-if="obj.membro.funcionario != null && obj.membro.funcionario.cargo.pdr"><i class="fas fa-check-square"></i></span>
          </TableColumn>
          <TableColumn :IsDateOnly="true" :status="obj.status" :value="obj.membro.inicioAtividades" />
          <TableColumn :IsDateOnly="true" :status="obj.status" :value="obj.membro.terminoAtividades" />
          <TableColumn :IsCustom="true" :status="obj.status">
            <b-form-select v-if="obj.membro.funcionario != null && obj.membro.funcionario.cargo.pdr" @input="onSelectPdrFormulario(obj)" v-model="obj.formularioSelecionado" :options="obj.formularios"></b-form-select>
          </TableColumn>
        </tr>
      </Tables>
    </b-modal>

    <!-- Observação Rejeição de PDR -->
    <b-modal
      id="rejectPdrObs"
      :title="$lang.Common.LabelRejectReason"
      size="lg"
      v-model="showRejectPDR"
      v-if="showRejectPDR"
      :ok-title="$lang.Common.Buttons.Save"
      :cancel-title="$lang.Common.Buttons.Back"
      @ok="submitRejectPDR"
      no-close-on-backdrop
    >
      <textarea
        v-model="rejectReason"
        style="height: 150px"
        class="w-100"
      />
    </b-modal>

    <!-- Observação Zeramento de PDR -->
    <b-modal
      id="zeroPdrObs"
      :title="$lang.Common.LabelZeroReason"
      size="lg"
      v-model="showZeroPDR"
      v-if="showZeroPDR"
      :ok-title="$lang.Common.Buttons.Save"
      :cancel-title="$lang.Common.Buttons.Back"
      @ok="submitZeroPDR"
      no-close-on-backdrop
    >
      <textarea
        v-model="zeroReason"
        style="height: 150px"
        class="w-100"
      />
    </b-modal>

    <b-modal
      id="afterGeneratePDR"
      size="md"
      v-model="showAfterGeneratePDR"
      v-if="showAfterGeneratePDR"
      :ok-title="afterGeneratePDRModal.confirmButton"
      @ok="submitAfterGeneratePDR"
      ok-only
      no-close-on-backdrop>
      <template #modal-header="{ close }">
        <h5 class="modal-title">{{afterGeneratePDRModal.title}}</h5>
      </template>
      <div class="row">
        <div class="col-3 separator">
          <div class="modal-label">{{this.$lang.PCI.PDRForm.TableFields.Start}}:</div>
          <div>{{this.afterGeneratePDRModal.startDate}}</div>
        </div>
        <div class="col-3 separator">
          <div class="modal-label">{{this.$lang.PCI.PDRForm.TableFields.End}}:</div>
          <div>{{this.afterGeneratePDRModal.endDate}}</div>
        </div>
        <div class="col-3 separator">
          <div class="modal-label">{{this.$lang.PCI.PDRForm.TableFields.LateDays}}:</div>
          <div>{{this.afterGeneratePDRModal.lateDays}}</div>
        </div>
        <div class="col-3" v-if="afterGeneratePDRModal.isReadOnly">
          <div class="modal-label">Data de liberação:</div>
          <div>{{this.afterGeneratePDRModal.releaseDate}}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 lateDays-label" v-if="this.afterGeneratePDRModal.isLate">
          {{this.$lang.PCI.PDRForm.TableFields.LateDaysMessage}} {{(this.afterGeneratePDRModal.lateDays - this.afterGeneratePDRModal.daysToLate)}} {{this.$lang.PCI.PDRForm.TableFields.LateDaysMessageFinish}}
        </div>
      </div>
      <hr/>
      <div class="row">
        <div class="col-12">
          <div class="modal-label">{{this.$lang.PCI.PDRForm.TableFields.Observation}}:</div>
          <textarea
            style="height: 150px"
            class="w-100"
            v-model="afterGeneratePDRModal.observation"
            :disabled="afterGeneratePDRModal.isReadOnly"/>
        </div>
      </div>
    </b-modal>

    <b-modal
      ref="authorizePDR"
      size="xl"
      v-model="showAuthorizePDR"
      v-if="showAuthorizePDR"
      :ok-title="$lang.PCI.PDRForm.ConfirmationButton"
      @ok="submitAuthorizePDR"
      ok-only
      no-close-on-backdrop>
      <template #modal-header>
        <div class="d-flex align-items-center col-12">
          <img src="https://static.zopone.com.br/img/logotipo/header/zopone.png" style="width: 45px" />
          <span class="modalTitle ml-auto">
            {{$lang.PCI.PDR.ApprovalTitle}}
          </span>
          <button class="close" @click="onCloseAuthorizePDR">x</button>
        </div>
      </template>
      <Tables ref="tableGrid" v-if="montagemPdrList != null" class="col-mdEW-12 tabela"
              :columns="[$lang.PCI.PDRForm.TableFields.Function,
                        $lang.PCI.PDRForm.TableFields.Type,
                        $lang.PCI.PDRForm.TableFields.Employee,
                        $lang.PCI.PDRForm.TableFields.PDR,
                        $lang.PCI.PDRForm.TableFields.Start,
                        $lang.PCI.PDRForm.TableFields.End,
                        $lang.PCI.PDRForm.TableFields.Form]"
              :showSearch="false"
              :showPrint="false"
              :showDownload="false"
              :showFullscreen="false"
              :showPaging="false">
        <tr v-for="obj in this.montagemPdrList" :key="obj.membro.id">
          <TableColumn :IsText="true" :status="obj.status" :value="obj.membro.funcaoObra.nome" />
          <TableColumn :IsText="true" :status="obj.status" :value="tipoServico(obj.membro.tipoServico)" />
          <TableColumn :IsText="true" :status="obj.status" :value="obj.membro.nome" />
          <TableColumn :IsCustom="true" class="text-center" style="font-size:15px; color:gray;">
            <span v-if="!(obj.membro.funcionario != null && obj.membro.funcionario.cargo.pdr)"><i class="far fa-square"></i></span>
            <span v-if="obj.membro.funcionario != null && obj.membro.funcionario.cargo.pdr"><i class="fas fa-check-square"></i></span>
          </TableColumn>
          <TableColumn :IsDateOnly="true" :status="obj.status" :value="obj.membro.inicioAtividades" />
          <TableColumn :IsDateOnly="true" :status="obj.status" :value="obj.membro.terminoAtividades" />
          <TableColumn :IsText="true" :status="obj.status" :value="obj.membro.pdrFormulario ? obj.membro.pdrFormulario.descricao : ''" />
        </tr>
      </Tables>
      <div class="row">
        <div class="col-12">
          <b-form-group :label="$lang.PCI.PDRForm.TableFields.Observation">
            <b-textarea
              style="height: 150px"
              class="w-100"
              v-model="authorizePDRModal.observation"/>
          </b-form-group>
        </div>
      </div>
    </b-modal>

    <cop ref="cop" v-if="showCopOf" @hide="onHideCop" @showTeam="viewTeam()" :readOnly="copReadOnly" />
    <cop-smartpci ref="copSmart" v-if="showCopSmart" @hide="onHideCopSmart" />
    <construction-address ref="address" v-if="showConstructionAddress" @update="onUpdateAddress" @hide="showConstructionAddress = false" :validation="constructionAddressValidation" />
    <construction-team ref="team" v-if="showConstructionTeam" @update="onUpdateTeam" @close="onCloseTeam" />
    <construction-candidate ref="candidate" v-if="showConstructionCandidate" @close="onUpdateCandidates" />
    <tec-analysis ref="tecAnalysis" v-if="showTecAnalysis" @Update="onUpdateTecAnalysis" @Hide="showTecAnalysis = false" @SelectFolder="selectZdocsFolder" @OpenFolder="showZdocsFolder"/>
    <purchase-order-client ref="po" v-if="showPo" @close="showPo = false" @hide="restoreFocus()" />
    <bills ref="bills" v-if="showBills" @close="showBills = false" @hide="restoreFocus()" />
    <purchase-order ref="purchaseorder" v-if="showPurchaseOrder" @close="showPurchaseOrder = false" @hide="restoreFocus()" />
    <stoppage ref="stoppage" v-if="showStoppage" @close="showStoppage = false" @update="onUpdateStoppage" />
    <cancellation ref="cancellation" v-if="showCancellation" @close="showCancellation = false" @update="onUpdateCancellation" />
    <considerations ref="considerations" v-if="(hasRole(roles.RW_OPER_PCI_DOCUMENTATION) || hasRole(roles.R_OPER_PCI_DOCUMENTATION)) && showConsiderations" @close="showConsiderations = false" />
    <annex ref="annex" v-if="(hasRole(roles.RW_OPER_PCI_DOCUMENTATION)|| hasRole(roles.R_OPER_PCI_DOCUMENTATION)) && showAnnex" @close="showAnnex = false" />
    <resume ref="resume" v-if="hasRole(roles.RW_OPER_PCI_REPORT) && showResume" @close="showResume = false" />
    <tec-analysis-na ref="tecAnalysisNa" v-if="showTecAnalysisNa" @update="onUpdateTecAnalysisNa" @hide="showTecAnalysisNa = false" />
    <report-juridico-contrato v-if="openReport" :dados="dataReport" @close="openReport = false" />
  </div>
</template>

<script>
import PCI from './pci'
export default PCI
</script>

<style scoped>

.lateDays-label{
  background-color:red;
  text-align:right;
  font-weight:bolder;
  color:#FFF
}
.modal-label {
  font-size: smaller;
  font-weight: bold;
}
.separator {
  border-right: 1px solid rgba(0,0,0,.1);
}
div.pci-header {
  height: 35px;
  width: 100%;
  background-color: white;
}

.v-select {
  --vs-line-height: 0;
  --vs-font-size: 0.65rem;
  font-size: var(--vs-font-size);
}

#filter-history.v-select >>> .vs__selected,
#filter-history.v-select >>> .vs_search {
  margin: 0;
  padding: 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 94vw;
}

.v-select >>> .vs__dropdown-toggle {
  padding: 0;
  margin: 0;
}

div.pci-header .pci-header-button {
  font-size: 14px; color: #000000b3;
}

#alerts-container  {
  position: absolute;
  width: 450px;
  background-color: #edf6f1;
  top: 38px;
  left: calc(100vw - 360px);
  height: auto;
  z-index: 1;
  padding: .35em .3em .1em .3em;
  box-shadow: 0 0 1em grey;
}

#quotes-container {
  position: absolute;
  width: 450px;
  background-color: #edf6f1;
  top: 38px;
  left: calc(100vw - 360px);
  height: auto;
  z-index: 1;
  padding: .35em .3em .1em .3em;
  box-shadow: 0 0 1em grey;
}

* >>> #pci-count .ag-column-drop {
  display: none;
}

* >>> .floatType, * >>> .integerType, * >>> .percentType {
  text-align: right;
}

#pci-load {
  position: fixed;
  top: 30px;
  right: 60px;
  width: 250px;
  z-index: 100;
  padding: 10px 15px;
  background: #f9f9f9;
  border: 1px solid #e6e6e6;
}

.bg-light-green {
  background: #edf6f1;
}

* >>> .nav-link {
  border-bottom: 1px;
}

/* * >>> button {
  font-size: 11px;
} */

* >>> .ag-theme-alpine .ag-menu-separator-part::after {
  border-bottom: 1px solid #e6e6e6;
}

* >>> .ag-theme-alpine .ag-column-drop-horizontal,
* >>> .ag-theme-alpine .ag-tool-panel-wrapper,
#pci {
  background: #ffffff !important;
  overflow: hidden;
}

#pci-count >>> .ag-ltr .ag-body-viewport,
* >>> .ag-ltr .ag-body-horizontal-scroll,
* >>> .ag-body-horizontal-scroll-viewport {
  background-color: #edf6f2;
}

* >>> .ag-theme-alpine .ag-tool-panel-wrapper,
* >>> .ag-ltr .ag-body-horizontal-scroll,
* >>> .ag-body-horizontal-scroll-viewport {
  border-right: 1px solid #dae0e5 !important;
}

*
  >>> .ag-theme-alpine
  .ag-ltr
  .ag-side-bar-left
  .ag-selected
  .ag-side-button-button,
*
  >>> .ag-theme-alpine
  .ag-rtl
  .ag-side-bar-right
  .ag-selected
  .ag-side-button-button {
  border-right-color: #008143 !important;
}

* >>> .ag-theme-alpine .ag-toggle-button-input-wrapper.ag-checked::before,
* >>> .ag-theme-alpine .ag-toggle-button-input-wrapper.ag-checked {
  border-color: #008143 !important;
}

* >>> .ag-theme-alpine .ag-toggle-button-input-wrapper.ag-checked {
  background: #008143;
}

* >>> .ag-theme-alpine .ag-side-button-button:hover,
* >>> .ag-theme-alpine .ag-checkbox-input-wrapper.ag-checked::after {
  color: #008143 !important;
}

* >>> .ag-theme-alpine .ag-checkbox-input-wrapper:active,
* >>> .ag-theme-alpine .ag-toggle-button-input-wrapper:focus-within {
  box-shadow: 0 0 2px 0.1rem rgba(0, 129, 67, 0.4);
}

* >>> .ag-input-field-input {
  filter: hue-rotate(240deg) !important;
}

* >>> .ag-pinned-left-cols-container {
  border-right: 1px solid #e6e6e6;
}

#company {
  margin: 10px;
}

* >>> .modal footer {
  background: #fff !important;
  border: 0px solid #474747;
  border-top-width: 3px;
  border-bottom-left-radius: 0.5rem !important;
  border-bottom-right-radius: 0.5rem !important;
}

#context {
  position: absolute;
  top: -1000px;
  left: -1000px;
  background: #d6f8e5;
  border: 1px solid #e6e6e6;
  z-index: 10;
}

.context-item {
  display: block;
  padding: 10px 20px;
  color: #303030;
}

.context-item:hover {
  background: #b9d6c6;
  text-decoration: none;
}

div#pci {
  width: 100%;
  height: 100%;
}

div#pci-grid {
  height: 100vh;
  overflow: hidden;
}

* >>> input[type="checkbox"] {
  filter: hue-rotate(230deg);
}

* >>> .context-item {
  color: var(--ag-foreground-color, #181d1f);
  font-size: 1rem !important;
}

.formularioAvaliacaoTitulo span {
  font-weight: bold;
}

#div-buttons {
  text-align: right;
}

* >>> div.field-with-alert {
  background-color: #f77777 !important;
}

* >>> div.field-with-alert.ag-cell-range-single-cell {
  background-color: #fd2929 !important;
}

* >>> div.field-formula-with-invoice {
  background-color: #fcb42e !important;
}

* >>> div.field-formula-with-invoice.ag-cell-range-single-cell {
  background-color: #c78c1f !important;
}

* >>> .ag-body.ag-layout-normal * {
  overflow-x: hidden;
}
* >>> .ag-body-horizontal-scroll * {
  height: 17px !important;
  max-height: 17px !important;
}

* >>> .alert-custom:hover {
  text-shadow: 1px 1px lightgray;
  border: #008143 solid 1px;
}

* >>> .quotes-custom:hover {
  text-shadow: 1px 1px lightgray;
  border: #008143 solid 1px;
}

* >>> div#alerts-container {
  z-index: 10 !important;
  width: 445px;
  left: calc(100vw - 450px);
  max-height: 93vh;
}

* >>> div#quotes-container {
  z-index: 10 !important;
  width: 445px;
  left: calc(100vw - 450px);
  max-height: 93vh;
}

* >>> div#alerts-container > div#alert-cards {
  overflow-y: auto;
  height: calc(93vh - 45px);
}
* >>> div.alert-group {
  width: 2rem;
  height: 2rem;
}
* >>> div.alert-group.selected {
  background-color: lightgray;
}

* >>> div#quotes-container div#quotes-cards {
  overflow-y: auto;
  height: calc(93vh - 65px);
}
* >>> div#quotes-container .card .card-body {
  padding: 4px;
}
* >>> div#quotes-container i.fas {
  font-size: 15px;
  text-shadow: -1px 1px 2px #615e5e;
}
* >>> div#quotes-container i.revision {
  color: rgb(164, 59, 185);
}
* >>> div#quotes-container i.filled {
  color: white;
}
* >>> div#quotes-container i.plan-approve {
  color: yellow;
}
* >>> div#quotes-container i.reg-approve {
  color: #fbc259;
}
* >>> div#quotes-container i.finished {
  color: #0eff8d;
}
* >>> div#quotes-container i.rejected {
  color: #ff2700;
}

.z-tooltip {
  position: relative;
  display: inline-block;
}
.z-tooltip .z-tooltiptext {
  visibility: hidden;
  background-color: black;
  color: #f5f5f5;
  text-align: center;
  border-radius: 6px;
  padding: 5px;
  text-wrap: nowrap;
  border: 1px solid #f5f5f5;

  opacity: 0;
  transition: opacity 1s;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
}
.z-tooltip .z-tooltiptext.z-position-bottomleft {
  top: 120%;
  right: 10px;
}
.z-tooltip .z-tooltiptext.z-position-bottomright {
  top: 120%;
  left: 10px;
}
.z-tooltip:hover .z-tooltiptext {
  visibility: visible;
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/pci.vue